<template>
	<div class="sideways-content-fold" v-if="activePanel">
		<div class="portlet light bordered" v-if="process !== 'next_actions'">
			<div class="portlet-title">
				<div class="caption">
					Create A Location
				</div>
			</div>
			<div class="portlet-body portlet-overflow">
				<form role="form" @submit.prevent="createLocation($event)" novalidate>
					<div class="alert alert-danger" v-if="errorMessage.length">
					    <button class="close" data-close="alert" @click="clearError()"></button>
                        <span>{{ errorMessage }}</span>
					</div>
					<transition name="fade" mode="out-in">
						<div v-if="process === 'step_1'" key="step_1">
							<div class="form-body invite-user-form">
								<div class="form-group form-md-line-input form-md-floating-label">
		                            <input type="text" class="form-control input-sm" :class="{'edited': newLocation.location_name.length}" id="create_location_name" v-model.trim="newLocation.location_name" maxlength="255">
		                            <label for="create_location_name">Location Name</label>
		                        </div>
		                        <div class="form-group form-md-line-input form-md-floating-label">
		                            <input type="text" class="form-control input-sm" :class="{'edited': newLocation.unoapp_defined_name.length}" id="create_unoapp_defined_name" v-model.trim="newLocation.unoapp_defined_name" maxlength="255">
		                            <label for="create_unoapp_defined_name">UNOapp Reference Name</label>
		                            <span class="help-block persist">The client will not see this name but can be used for internal reference.</span>
		                        </div>
		                        <div class="form-group form-md-line-input form-md-floating-label">
		                            <input type="number" class="form-control input-sm" :class="{'edited': newLocation.store_number}" id="create_location_store_number" v-model.trim="newLocation.store_number">
		                            <label for="create_location_store_number">Store Number <small class="font-grey-cascade">(optional)</small></label>
		                        </div>
		                        <div class="form-group form-md-line-input form-md-floating-label">
		                            <input type="text" class="form-control input-sm" :class="{'edited': newLocation.salesforce_id}" id="create_location_salesforce" v-model.trim="newLocation.salesforce_id">
		                            <label for="create_location_salesforce">Salesforce ID <small class="font-grey-cascade">(optional)</small></label>
		                        </div>
							</div>
							<div class="form-actions noborder invite-user-actions">
								<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To Business Dashboard</button>
								<button type="button" class="btn blue" @click="advanceForm($event, 'step_2', 'step_1')" key="create-location-continue-one">Continue <i class="fa fa-arrow-circle-right"></i></button>
							</div>
						</div>
						<div v-if="process === 'step_2'" key="step_2">
							<div class="form-body invite-user-form">
								<google-places-search :passedValue="newLocation.location_name" :confirmationMessage="confirmationMessage" @selectedLocation="selectedLocationUpdated" :currentSelectedLocation="newLocation.selected_location"></google-places-search>
							</div>
							<div class="form-actions noborder invite-user-actions">
								<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To Business Dashboard</button>
								<button type="button" class="btn btn-default" @click="reverseForm()">Back</button>
								<button type="button" class="btn blue" @click="advanceForm($event, 'step_3', 'step_2')" key="create-location-continue-one">Continue <i class="fa fa-arrow-circle-right"></i></button>
							</div>
						</div>
						<div v-if="process === 'step_3'" key="step_3">
							<div class="form-body invite-user-form">
								<google-maps-pin-confirmation :passedValue="newLocation.selected_location" @updateLocationLatLng="locationLatLngUpdated"></google-maps-pin-confirmation>
							</div>
							<div class="form-actions noborder invite-user-actions">
								<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To Business Dashboard</button>
								<button type="button" class="btn btn-default" @click="reverseForm()">Back</button>
								<button type="button" class="btn blue" @click="advanceForm($event, 'step_4', 'step_3')" key="create-location-continue-one">Confirm &amp; Continue <i class="fa fa-arrow-circle-right"></i></button>
							</div>
						</div>
						<div v-if="process === 'step_4'" key="step_5">
							<div class="alert alert-danger" v-if="!regions.length">
								<span>Regions are required to set up locations.</span>
							</div>
							<loading-screen :show="loadingRegionData" :color="'#3598dc'" :display="'inline'"></loading-screen>
							<div class="mt-element-list mt-element-overflow" v-if="!regions.length && loadingRegionData === false">
								<div class="mt-list-container list-default no-border">
									<ul>
										<li class="mt-list-item">
											<div class="list-icon-container done">
												<a>
													<i class="fa fa-globe"></i>
												</a>
											</div>
											<div class="list-item-content">
												<h3 class="uppercase bold">
													<router-link to="/app/my_business/regions">Go to the regions dashboard</router-link>
												</h3>
												<p><small>Regions can be used to assign users as admins to groups of locations we well as to market location based content to a group of locations.</small></p>
											</div>
										</li>
									</ul>
								</div>
							</div>
							<div v-if="regions.length && loadingRegionData === false">
								<div class="mt-element-list">
									<div class="mt-list-container list-simple ext-1 group no-border">
										<a class="list-toggle-container" v-if="regionPath.length" @click="goUpOneLevel()">
											<div class="list-toggle not-selected">
												<span class="fa fa-chevron-left margin-right-10"></span>
												Go back to {{ regionPath.length > 1 ? regionPath[regionPath.length - 2].name : 'base regions' }}
											</div>
										</a>
										<template v-for="region in computedRegions">
											<a class="list-toggle-container" @click="selectRegion(region)">
												<div class="list-toggle uppercase" :class="{'not-selected': newLocation.region.id !== region.id}">
													{{ region.name }}
													<span v-if="region.has_children" class="pull-right fa fa-chevron-right"></span>
												</div>
											</a>
										</template>
									</div>
								</div>
							</div>
							<div class="form-actions noborder invite-user-actions margin-top-20" v-if="regions.length && loadingRegionData === false">
								<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To Business Dashboard</button>
								<button type="button" class="btn btn-default" @click="reverseForm()">Back</button>
								<button type="button" class="btn blue" @click="advanceForm($event, 'step_5', 'step_4')" key="create-location-continue-one">Confirm &amp; Continue <i class="fa fa-arrow-circle-right"></i></button>
							</div>
						</div>
						<div v-if="process === 'step_5'" key="step_5">
							<div class="form-body invite-user-form">
								<div class="margin-top-20 portlet-title-alternate">Build a Product Package</div>
								<div class="margin-top-20 row search-content-4">
			      					<div class="search-table table-responsive">
			      						<table class="table table-striped table-condensed">
			      							<thead>
			      								<tr>
			      									<th></th>
			      									<th><a class="no-click font-grey-mint">Include App</a></th>
			      								</tr>
			      							</thead>
			      							<tbody>
			      								<tr v-for="app in apps">
				      								<td><h4>{{ app.app_name }}</h4></td>
				      								<td>
				      									<div class="md-checkbox">
				      										<input type="checkbox" :id="`app_access_location_${app.app_id}`" class="md-check" v-model="app.location_access">	
				      										<label :for="`app_access_location_${app.app_id}`">
				      											<span></span>
				      											<span class="check"></span>
				      											<span class="box"></span>
				      										</label>
				      									</div>
				      								</td>
				      							</tr>
			      							</tbody>
			      						</table>
			      					</div>
			      				</div>
							</div>
							<div class="form-actions noborder invite-user-actions">
								<button type="button" class="btn btn-default exit-invitation-setup" @click="closePanel()"> Return To Business Dashboard</button>
								<button type="button" class="btn btn-default" @click="reverseForm()">Back</button>
								<button type="submit" class="btn blue" key="create-location-confirm">Submit</button>
							</div>
						</div>
					</transition>
					<step-counter :steps="steps" :process="process"></step-counter>
				</form>
			</div>
		</div>
		<next-actions v-else :actionsList="createLocationNextActions" @runFunction="runFunction"></next-actions>
	</div>
</template>
<script>
import $ from 'jquery'
import GoogleMapsPinConfirmation from '../../../modules/GoogleMapsPinConfirmation'
import GooglePlacesSearch from '../../../modules/GooglePlacesSearch'
import LoadingScreen from '../../../modules/LoadingScreen'
import NextActions from '../../../modules/NextActions'
import StepCounter from '../../../modules/StepCounter'
import { findIndex, filter, forEach } from 'lodash'
import GlobalFunctions from '../../../../global'
import Business from '../../../../controllers/Business'
import Location from '../../../../controllers/Location'
import Region from '../../../../controllers/Region'
import { mapGetters } from 'vuex'

/**
 * Create Location module is a page for creating new locations.
 * @class CreateLocation
 * @extends Locations
 * @since 0.0.8
 */

export default {
	name: 'create-location',
	data () {
		return {
			process: 'step_1',
			activePanel: false,
			errorMessage: '',
			newLocation: {
				location_name: '',
				unoapp_defined_name: '',
				store_number: '',
				salesforce_id: '',
				region: {}
			},
			confirmationMessage: 'Click <b class="font-green-sharp">&#39;Continue&#39;</b> to confirm that this is your location.',
			steps: [{key: 'step_1', name: 'Location Info'}, {key: 'step_2', name: 'Google Location'}, {key: 'step_3', name: 'Verify Location'}, {key: 'step_4', name: 'Select Region'}, {key: 'step_5', name: 'Product Package'}],
			apps: [],
			regions: [],
			regionPath: [],
			loadingRegionData: false,
			createLocationNextActions: [{title: 'Set Up Location Profile', icon_class: 'fa fa-map-marker', main_action: true, description: 'A location profile contails details about your location.'}, {title: 'Create Another Location', icon_class: 'fa fa-map-marker', click_event: 'resetProcess'}, {title: 'Return to Locations Dashboard', icon_class: 'fa fa-arrow-circle-left', click_event: 'closePanel'}]
		}
	},
	/**
	 * Run on `created` to determine if this should be the active panel or not.
	 * @function
	 * @return {undefined}
	 * @memberof CreateLocation
	 * @version 0.0.8
	 */
	created () {
		if (this.$route.name === 'My Business Locations - Create Location') {
			this.activePanel = true
			this.getAppList()
			this.getRegions()
		}
	},
	computed: {
		/**
		 * To set the regions showing at the current level of the tree.
		 * @function
		 * @returns {array} - An array of the current regions to show
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		computedRegions () {
			if (!this.regionPath.length) {
				return this.regions
			} else {
				return this.regionPath[this.regionPath.length - 1].children
			}
		},
		...mapGetters([
			'activeBusinessId'
		])
	},
	methods: {
		/**
		 * To clear the current error.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		clearError () {
			this.errorMessage = ''
		},
		/**
		 * To close the create location panel by redirecting to the dashboard
		 * @function
		 * @returns {undefined}
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		closePanel () {
			this.process = 'step_1'
			this.$router.push('/app/my_business/locations')
		},
		/**
		 * To validate that all information on the current step is accurate before allowing the user to proceed.
		 * @function
		 * @param {string} step - The step to be tested.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		validateFormData (step) {
			let _this = this

			return new Promise((resolve, reject) => {
				switch (step) {
				case 'step_1':
					if (_this.newLocation.location_name.length < 3) {
						reject('Location name must be at least 3 characters')
					}
					break

				case 'step_2':
					if (!_this.newLocation.selected_location || !_this.newLocation.selected_location.id) {
						reject('You must select a location before continuing.')
					}
					break

				case 'step_4':
					if (!_this.newLocation.region || !_this.newLocation.region.id) {
						reject('You must select a region before continuing.')
					}
					break

				case 'step_5':
					const locationAppsSelected = _this.apps.filter(app => { return app.location_access }).length >= 1

					if (!locationAppsSelected) {
						return _this.$swal({
							title: 'Are you sure?',
							html: 'Do you want to create this location with no app access?',
							type: 'warning',
							showCancelButton: true,
							confirmButtonText: 'Create Location',
							confirmButtonColor: '#d9534f',
							cancelButtonText: 'Cancel',
							allowOutsideClick: false,
							allowEscapeKey: false,
							allowEnterKey: false,
							showLoaderOnConfirm: true
						}).then(() => {
							resolve()
						}, dismiss => {
							reject()
						})
					}
					break

				default:
					resolve()
				}

				resolve()
			})
		},
		/**
		 * To move the form back to the previous step
		 * @function
		 * @returns {undefined}
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		reverseForm () {
			const index = findIndex(this.steps, ['key', this.process])
			this.clearError()

			if (index) {
				this.process = this.steps[index - 1].key
			}

			if (this.process !== 'step_2') {
				if ($(document).find('.pac-container').length) {
					$(document).find('.pac-container').remove()
				}
			}

			return
		},
		/**
		 * To move to the next step of the form.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @param {string} step - The step that we are moving to.
		 * @param {string} currentStep - The current step.
		 * @returns {undefined}
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		advanceForm (event, step, currentStep) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			return this.validateFormData(currentStep).then(response => {
				_this.clearError()
				disabledButton.complete().then(() => {
					_this.process = step
				})
			}).catch(reason => {
				// If validation fails then display the error message
				_this.errorMessage = reason
				disabledButton.cancel()
			})
		},
		/**
		 * To pull in a list of all available apps to be chosen from for the new location.
		 * @function
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		getAppList () {
			let _this = this

			return Business.getBusinessDetails(this.activeBusinessId).then(response => {
				const defaultApps = {location_access: false}
				_this.apps = response.payload.apps

				_this.apps.forEach((apps, index, allApps) => {
					allApps[index] = Object.assign({}, apps, defaultApps)
				})
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {

					default:
						// No default
					}
				}
			}))
		},
		/**
		 * To filter the selected apps for use with the create location endpoint
		 * @function
		 * @returns {array} An array of app ids
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		formatAppData () {
			let appData = []

			let filteredApps = filter(this.apps, 'location_access')

			forEach(filteredApps, (value) => {
				appData.push(value.app_id)
			})

			return appData
		},
		/**
		 * To get a list of child regions under the current parent.
		 * @function
		 * @param {integer} parentId - The parent region that we are retrieving results for.
		 * @returns {object} - A promise that will either return an error message or perform an action.
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		getRegions (parentId) {
			this.loadingRegionData = true

			let _this = this
			const businessId = this.activeBusinessId

			return Region.getRegions(businessId, parentId).then(response => {
				if (parentId) {
					let i = 0
					let runningRegion = {}
					while (i < _this.regionPath.length) {
						if (i > 0) {
							runningRegion.children.forEach(region => {
								if (region.id === _this.regionPath[i].id) {
									if (region.id === parentId) {
										region.children = response.payload.regions
										_this.regionPath.splice(i, 1, region)
									} else {
										runningRegion = region
									}
								}
							})
						} else {
							_this.regions.forEach(region => {
								if (region.id === _this.regionPath[i].id) {
									if (region.id === parentId) {
										region.children = response.payload.regions
										_this.regionPath.splice(i, 1, region)
									} else {
										runningRegion = region
									}
								}
							})
						}
						i += 1
					}
				} else {
					_this.regions = response.payload.regions
				}
				setTimeout(() => { _this.loadingRegionData = false }, 100)
			}).catch(_this.$root.errorWrapper(e => {
				if (e.responseJSON) {
					switch (e.responseJSON.declaration) {
					case 'business_not_found':
						_this.$swal({
							title: 'Error',
							html: 'There is an issue with your business account. Please contact your admin.',
							type: 'warning'
						})
						break

					case 'invalid_region':
						break

					case 'regions_not_found':
						if (!parentId) {
							_this.noRegions = true
						}
						break

					case 'parent_region_not_found':
						break

					default:
						// No default
					}
				}
				setTimeout(() => { _this.loadingRegionData = false }, 100)
			}))
		},
		/**
		 * To select the current region and determine whether we need to pull it's children.
		 * @function
		 * @param {object} region - The region that we are selecting.
		 * @returns {undefined}
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		selectRegion (region) {
			if (region.has_children) {
				this.drillDown(region)
			} else {
				this.newLocation.region = region
			}
		},
		/**
		 * To set the current region and drill down into it's children.
		 * @function
		 * @param {object} region - The current region that we are drilling into.
		 * @returns {undefined}
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		drillDown (region) {
			this.regionPath.push(region)
			this.getRegions(region.id)
		},
		/**
		 * To move up a level in the tree.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		goUpOneLevel () {
			this.regionPath.pop()
		},
		/**
		 * To send the details of the new location to the backend.
		 * @function
		 * @param {object} event - The click event that prompted this function.
		 * @returns {object} A promise that will either return an error message or display the success screen.
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		createLocation (event) {
			let disabledButton = GlobalFunctions.disableButton(event)
			let _this = this

			this.newLocation.apps = this.formatAppData()

			return _this.validateFormData('step_5')
			.then(response => {
				_this.clearError()

				if (!_this.newLocation.unoapp_defined_name) {
					_this.newLocation.unoapp_defined_name = _this.newLocation.location_name
				}

				Location.createLocation(_this.activeBusinessId, _this.newLocation).then(response => {
					_this.clearForm()
					_this.process = 'next_actions'
					disabledButton.complete()
				}).catch(_this.$root.errorWrapper(e => {
					if (e.responseJSON) {
						switch (e.responseJSON.declaration) {
						case 'already_exists':
							_this.errorMessage = 'A location with this name already exists. Please choose a different name.'
							_this.process = 'step_1'
							break

						default:
							// No default
						}
					}
					disabledButton.cancel()
				}))
			}).catch(reason => {
				// If validation fails then display the error message
				if (reason) {
					_this.errorMessage = reason
				}
				disabledButton.cancel()
			})
		},
		/**
		 * To set the selected location to the newLocation model.
		 * @function
		 * @param {object} val - The selected location being recieved from the Google API.
		 * @returns {undefined}
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		selectedLocationUpdated (val) {
			this.newLocation.selected_location = val
		},
		/**
		 * To update the map marker coordinates of the selected location.
		 * @function
		 * @param {object} val - The coordinates being recieved from the Google API.
		 * @returns {undefined}
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		locationLatLngUpdated (val) {
			this.newLocation.selected_location.coordinates = val
		},
		/**
		 * To clear the object 'newLocation'.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		clearForm () {
			this.newLocation = {
				location_name: '',
				unoapp_defined_name: '',
				store_number: '',
				salesforce_id: '',
				region: {},
				selected_location: {}
			}
			this.regionPath = []
			$('.invite-user-form').find('input, select').removeClass('edited')
		},
		/**
		 * To reset the panel to display the form.
		 * @function
		 * @returns {undefined}
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		resetProcess () {
			this.process = 'step_1'

			forEach(this.apps, (value) => {
				value.location_access = false
			})
		},
		/**
		 * To run the function passed in.
		 * @function
		 * @param {string} functionName - The function that is to be run
		 * @param {array} params - The list of parameters being passed into the function
		 * @returns {undefined}
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		runFunction (functionName, params) {
			if (!params) {
				this[functionName]()
			} else {
				this[functionName](params[0])
			}
		}
	},
	components: {
		GoogleMapsPinConfirmation,
		GooglePlacesSearch,
		LoadingScreen,
		NextActions,
		StepCounter
	},
	watch: {
		/**
		 * To `watch` the $route in order to determine if this panel should be showing or not
		 * @function
		 * @returns {undefined}
		 * @memberof CreateLocation
		 * @version 0.0.8
		 */
		'$route' () {
			if (this.$route.name === 'My Business Locations - Create Location') {
				this.activePanel = true
				this.process = 'step_1'
				this.getAppList()
				this.getRegions()
				this.clearForm()
			} else {
				this.activePanel = false
			}
		}
	}
}
</script>
<style>
.mt-element-list .list-simple.mt-list-container.no-border {
	border: none;
	border-top: 1px solid #e7ecf1;
}
.mt-element-list .list-simple.group .list-toggle-container .list-toggle.not-selected {
	background-color: #fff;
	color: #34495e;
	border-bottom: 1px solid #e7ecf1;
}
</style>



// WEBPACK FOOTER //
// CreateLocation.vue?ae44c300